import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

const AllOrders = () => {
  const [orders, setOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortAsc, setSortAsc] = useState(true);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const agentId = query.get('agentId');
  const agentName = query.get('agentName');
  const selectedMonth = parseInt(query.get('month'));
  const selectedYear = parseInt(query.get('year'));
  const BASE_URL = process.env.REACT_APP_API_URL || '';
  

  useEffect(() => {
    if (!agentId) return;

    const fetchOrders = async () => {
      try {
        const gmResponse = await axios.get(`${BASE_URL}/api/agents?id=${agentId}`);
        const mobResponse = await axios.get(`${BASE_URL}/api/mobility?id=${agentId}`);

        const gmData = gmResponse.data || [];
        const mobData = (mobResponse.data || []).map(order => ({
          Order_Number: order.ORDER_REF_NO,
          SEGMENT: "MOB",
          Activation_Date: order.GM_ACTIVATION_DT,
          Units: "0.5",
          Agent_Name: order.FULL_NAME
        }));

        const combinedOrders = [...gmData, ...mobData];

        const filtered = combinedOrders.filter(order => {
          const date = new Date(order.Activation_Date);
          //return date.getMonth() === selectedMonth && date.getFullYear() === selectedYear;
          return date.getUTCMonth() === selectedMonth && date.getUTCFullYear() === selectedYear;
	});

        setOrders(filtered);
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    };

    fetchOrders();
  }, [agentId, selectedMonth, selectedYear]);

  const filteredOrders = orders
    .filter(order => order.Order_Number.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => {
      const dateA = new Date(a.Activation_Date);
      const dateB = new Date(b.Activation_Date);
      return sortAsc ? dateA - dateB : dateB - dateA;
    });

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 text-white px-6 py-10">
      <div className="max-w-6xl mx-auto bg-white/5 border border-white/10 rounded-2xl p-8 shadow-2xl">
        <h1 className="text-3xl font-bold mb-6 text-center">📦 Order Details for Agent {agentId}</h1>
        <div className="flex justify-between items-center mb-4">
          <input
            type="text"
            placeholder="Search by Order Number"
            className="p-2 rounded bg-slate-800 text-white border border-gray-600"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            onClick={() => setSortAsc(!sortAsc)}
            className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded text-white font-semibold"
          >
            Sort by Date ({sortAsc ? 'Asc' : 'Desc'})
          </button>
        </div>

        {filteredOrders.length === 0 ? (
          <p className="text-center text-gray-400">No orders found for the selected month.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-600 text-sm">
              <thead className="bg-slate-800 text-gray-300">
                <tr>
                  <th className="px-4 py-3 text-left">Order Number</th>
                  <th className="px-4 py-3 text-left">Segment</th>
                  <th className="px-4 py-3 text-left">Date of Installation</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-700">
                {filteredOrders.map((order, idx) => (
                  <tr key={`${order.Order_Number}-${order.SEGMENT}-${idx}`} className="hover:bg-slate-800">
                    <td className="px-4 py-2">{order.Order_Number}</td>
                    <td className="px-4 py-2">{order.SEGMENT}</td>
                    <td className="px-4 py-2">{order.Activation_Date? new Date(order.Activation_Date).toLocaleDateString('en-US', { timeZone: 'UTC' }): ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllOrders;
